import React, { useEffect, useState } from "react";
import { useCallback } from "react";
import { Button } from "react-bootstrap";
import BootstrapTable from "react-bootstrap-table-next";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import BackButton from "../../../components/Form/BackButton";
import { API, defaultLimitPagination, get } from "../../../config";
import Pagination from "../../common/Pagination";
import Spin from "../../common/Spin";
import { debounce } from "lodash";
import HolidaysActionButton from "./components/HolidaysActionButton";
import AddHolidays from "./AddHolidays";
import SearchBox from "../../common/SearchBox";

const Holidays = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const query = new URLSearchParams(location.search);
  const search = query.get("search");
  const defaultPage = query.get("page");
  const defaultLimit = query.get("limit");
  const [holidaysList, setHolidaysList] = useState([]);
  const [holidaysLoading, setHolidaysLoading] = useState(false);
  const [sortField, setSortField] = useState();
  const [sortOrder, setSortOrder] = useState();
  const [searchParam, setSearchParam] = useState(search || "");
  const [searchParamData, setSearchParamData] = useState(search || "");

  const [page, setPage] = useState(defaultPage || 1);
  const [limit, setLimit] = useState(defaultLimit || defaultLimitPagination);
  const [total, setTotal] = useState();
  const [from, setFrom] = useState();
  const [to, setTo] = useState();

  const [showHolidays, setShowHolidays] = useState(false);

  // *API Call for Geting Holidays - Start
  const fetchHolidays = useCallback(
    async (passLimit, passPage) => {
      try {
        setHolidaysLoading(true);
        const { data } = await get(
          `${API.GET_HOLIDAY}?limit=${
            passLimit ? passLimit : limit ? limit : defaultLimitPagination
          }&page=${passPage ? passPage : page ? page : 1}&search=${
            searchParam ? searchParam : ""
          }&sort_column=${sortField ? sortField : ""}&sort_order=${
            sortOrder ? sortOrder : ""
          }`
        );
        setHolidaysLoading(false);
        setLimit(data?.data?.per_page);
        setPage(data?.data?.current_page);
        setTotal(data?.data?.total);
        setFrom(data?.data?.from);
        setTo(data?.data?.to);
        const holidayList = data?.data?.data;
        setHolidaysList(holidayList);
        return 0;
      } catch (error) {
        setHolidaysLoading(false);
        setHolidaysList([]);

        if (error?.response?.data?.errors) {
          Object.keys(error?.response?.data?.errors).forEach((key) => {
            toast.error(error?.response?.data?.errors[key][0]);
          });
        } else {
          toast.error(error?.message);
        }
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [searchParam, sortOrder, sortField]
  );

  const holidaysModal = () => {
    fetchHolidays(limit, page);
  };

  useEffect(() => {
    fetchHolidays();
  }, [fetchHolidays]);
  // *API Call for Geting Holidays - End

  // *Holidays Table Row and Column Generation, Filtering and Sorting of Record - Start
  const holidaysGenerator = (quantity) => {
    const items = [];
    for (let i = 0; i < quantity; i++) {
      items.push({
        key: holidaysList[i]?.id,
        id: holidaysList[i]?.id ? holidaysList[i]?.id : "",
        date: holidaysList[i]?.date ? holidaysList[i]?.date : "",
        name: holidaysList[i]?.name ? holidaysList[i]?.name : "",
        description: holidaysList[i]?.description
          ? holidaysList[i]?.description
          : "",
        action: (
          <HolidaysActionButton
            id={holidaysList[i]?.id}
            holidaysModal={holidaysModal}
          />
        ),
      });
    }
    return items;
  };
  const holidaysData = holidaysGenerator(holidaysList?.length);

  const columns = [
    {
      dataField: "date",
      text: "Date",
      sort: true,
    },
    {
      dataField: "name",
      text: "Name",
      sort: true,
    },
    {
      dataField: "description",
      text: "Description",
      sort: true,
    },
    {
      dataField: "action",
      text: "Action",
      className: "text-center",
      style: { width: "127px" },
    },
  ];

  const handleTableChange = (type, { page, sortField, sortOrder }) => {
    if (type === "sort") {
      setPage(1);
      setSortField(sortField);
      setSortOrder(
        sortOrder === "asc" ? "ASC" : sortOrder === "desc" && "DESC"
      );
    }
  };

  // const onSearchChange = (e) => {
  //   const value = e.target.value;
  //   setSearchParam(value);
  //   setPage(1);
  // };

  const handleUpdateLimit = (e) => {
    const limit = e.target.value;
    setLimit(limit);
    setPage(1);
    fetchHolidays(limit, 1);
  };

  const handleChangePage = (page) => {
    setPage(page);
    fetchHolidays(limit, page);
  };
  // *Holidays Table Row and Column Generation, Filtering and Sorting of Record - End

  useEffect(() => {
    navigate(
      `/admin/holidays?limit=${limit ? limit : defaultLimitPagination}&page=${
        page ? page : 1
      }&search=${searchParam ? searchParam : ""}&sort_column=${
        sortField ? sortField : ""
      }&sort_order=${sortOrder ? sortOrder : ""}`,
      {
        replace: true,
      }
    );
  }, [navigate, limit, searchParam, page, sortField, sortOrder]);

  const toggleHolidaysModal = () => {
    showHolidays && holidaysModal();
    setShowHolidays(!showHolidays);
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const debouncedSave = useCallback(
    debounce((nextValue) => {
      setSearchParam(nextValue);
      setPage(1);
    }, 300),
    []
  );

  const handleSearchChange = (event) => {
    const { value: nextValue } = event.target;
    setSearchParamData(nextValue);
    setPage(1);
    if (nextValue?.length >= 2 || nextValue?.length === 0) {
      debouncedSave(nextValue);
    }
  };

  const handleClearSearch = () => {
    setSearchParamData();
    setSearchParam("");
  };

  return (
    <>
      {" "}
      <div className="cms-page">
        <div className="page-content-block">
          <div className="full-content-block">
            <h1 className="page-title">
              <BackButton />
              QLD Public Holidays
            </h1>
            <div className="content-details">
              <div className="table-top-btn">
                <SearchBox
                  placeholder={"Search Holidays"}
                  searchParamData={searchParamData}
                  handleSearchChange={handleSearchChange}
                  handleClearSearch={handleClearSearch}
                />
                <div className="table-btn">
                  <Button variant="primary" onClick={toggleHolidaysModal}>
                    Add New
                  </Button>
                </div>
              </div>
              <div className="custom-table">
                {holidaysLoading && <Spin />}
                <BootstrapTable
                  keyField="holidays_id"
                  remote
                  data={holidaysData}
                  columns={columns}
                  onTableChange={handleTableChange}
                  noDataIndication="No Data Found"
                />
                <Pagination
                  total={total}
                  limit={parseInt(limit)}
                  currentPage={page}
                  updateLimit={handleUpdateLimit}
                  updatePage={handleChangePage}
                  from={from}
                  to={to}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      {showHolidays && (
        <AddHolidays
          toggleHolidaysModal={toggleHolidaysModal}
          holidaysModal={holidaysModal}
          showHolidays={showHolidays}
        />
      )}
    </>
  );
};

export default Holidays;
